module Meevo.Plugins.Controls {

    export interface IPieChartDataRow {
        key: string;
        y: number;
    }


    class MeevoPieChartComponent<T> extends BaseChart<T, IPieChartDataRow> {
        static $inject = ['$scope', '$element', '$timeout'];

        public options: Object;

        constructor($scope, $element, $timeout) {
            super($scope, $element, $timeout);

            this.options = {
                chart: {
                    type: 'pieChart',
                    height: 450,
                    x: function (d) {
                        return d.key;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    showLabels: true,
                    labelType: "percent",
                    duration: 1000,
                    labelThreshold: 0.10,
                    labelSunbeamLayout: false,
                    donut: true,
                    donutRatio: 0.40,
                    legend: {
                        margin: {
                            top: 5,
                            right: 35,
                            bottom: 5,
                            left: 0
                        }
                    }
                }
            };
        }

        $onInit() {
            super.$onInit();
        }
    }


    angular.module('meevo.components.controls')
        .component('meevoPieChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/pie-chart/pie-chart.html',
            controller: MeevoPieChartComponent,
            controllerAs: '$ctrl',
            bindings: {
                title: '@',
                inputData: '<',
                mapFn: '='
            }
        });
}
